import React from 'react';

import PropTypes from 'prop-types';
import Button from 'react-bootstrap/Button';
import Nav from 'react-bootstrap/Nav';

const EssentialLinksMenuItem = ({ displayName, url }) => {
    return (
        <Nav.Item className="essential-item">
            <Button href={url} target="_blank" tabIndex={1000}>
                { displayName }
            </Button>
        </Nav.Item>
    );
};

EssentialLinksMenuItem.propTypes = {
    displayName: PropTypes.string,
    url: PropTypes.string,
};

export default EssentialLinksMenuItem;
